export default {
  promoList: state => state.promoList,
  promoListExpired: state => state.promoListExpired,
  reminderList: state => state.reminderList,
  birthdayList: state => state.birthdayList,
  // clientList: state=> state.clientList,

  promoData: state => state.promoData,
  promoDataExpired: state => state.promoDataExpired,
  reminderData: state => state.reminderData,
  birthdayData: state => state.birthdayData,
  // clientData: state=> state.clientData

  newClient: state=> state.newClient,
  promotionInfo: state => state.promotionInfo,
  reminderInfo: state => state.reminderInfo,
  birthdayInfo: state => state.birthdayInfo,
  campaignHistoryList: state => state.campaignHistoryList
}
